<template>
  <div class="pt-0" style="padding-left: 2%; padding-right: 2%; background-color: #F8F9FA; min-height: 100vh;">
    <OverlayLoading :loading="loading" />
    <v-row class="mb-2">
      <v-col cols="8">
        <img width="17" height="17" src="@/assets/icons/back-icon.png" class="mt-5 ml-0" style="cursor: pointer;" @click="goBack()">
        <span class="header-title ml-0" style="font-size: 18px;">
          บริษัท: <span class="header-title" style="font-weight: 400; font-size: 16px;">{{company}} </span>
        </span>
        <span class="header-title ml-0" style="font-size: 18px;">
          สายบังคับบัญชา: <span class="header-title" style="font-weight: 400; font-size: 16px;">{{orgChartDetail}} </span>
        </span>
      </v-col>
      <v-col cols="4" class="pt-0 pb-0 d-flex align-center justify-end mt-0">
        <!-- <v-btn width="18%" class="ma-0" outlined color="#3776E9" dark @click="copyData()">History</v-btn> -->
        <v-btn class="ma-1 mr-2" color="#3776E9" dark @click="goCreateTransfer()">
          <v-icon
            color="#3776E9 darken-2"
            class="pl-0"
            small
          >
            mdi-account-multiple
          </v-icon>
          <span class="mx-1">โอนสิทธิ์</span>
        </v-btn>
      </v-col>
    </v-row>
    <div>
      <v-card height="auto" min-height="82vh" class="pt-7 pb-7" >
        <div class="text-left ml-8">
          <span class="blue--text text--darken-4 font-weight-bold mr-5 text-title-content">ประวัติการโอนสิทธิ์</span>
        </div>
        <v-row justify="center" align="center">
          <v-col cols="11" class="text-center ">
            <v-divider
            ></v-divider>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="6" lg="4" class="pt-0 pb-0 pl-12">
            <span class="head-search-text">ค้นหา</span>
            <v-autocomplete
              v-model="selectAuthenList"
              :items="authenList"
              item-text="name"
              item-value="_id"
              outlined
              dense
              clearable
              class="mt-2"
              placeholder="ค้นหาได้จากชื่อสิทธิ์"
              no-data-text="ไม่พบข้อมูล"
              @change="searchFilterData(), page=1"
              @click:clear="keywordServiceName='', searchFilterData(), page=1"
            >
            <template v-slot:append>
              <img width="24" height="24" src="@/assets/icons/search-icon-2.png" style="cursor: pointer;" @click="searchFilterData(), page=1">
            </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="1" class="pt-0 d-flex align-end" style="padding-bottom: 15px;">
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-width="200"
              :nudge-top='-10'
              max-width="328"
              left
              offset-y
              origin='left'
              tile
              z-index="0"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="head-search-button"
                  style="width: 96px; height: 38px;"
                  text
                  color="primary"
                  elevation="0"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon left>
                    mdi-filter-variant
                  </v-icon>
                  ตัวกรอง
                </v-btn>
              </template>
              <v-card class="pa-3">
                <v-row class="pt-3">
                  <v-col cols="12" class="pt-0 pb-0">
                    <span class="head-search-text">สถานะ</span>
                    <v-autocomplete
                      v-model="selectStatusAuthenList"
                      :items="statusAuthenList"
                      outlined
                      placeholder="ทั้งหมด"
                      no-data-text="ไม่พบข้อมูล"
                      class="mt-2"
                      dense
                      clearable
                    >
                    <template v-slot:[`item`]="{ item }">
                      <span style="color: rgba(0, 0, 0, 0.87);">{{ statusList.filter(e => e.status === item)[0].statusTH || '-' }}</span>
                    </template>
                    <template #selection="{ item }">
                      <span style="color: rgba(0, 0, 0, 0.87);">{{ statusList.filter(e => e.status === item)[0].statusTH || '-' }}</span>
                    </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row class="pt-3">
                  <v-col cols="12" sm="12" md="12" lg="12">
                    <span>วันที่โอนสิทธิ์</span><span style="color: red;"> *</span>
                    <v-menu
                      v-model="menuDate"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="selectDateStatus"
                          placeholder="เลือกวันที่เริ่ม"
                          persistent-hint
                          readonly
                          v-on="on"
                          outlined
                          dense
                        >
                        <template v-slot:append>
                          <img width="20" height="20" src="@/assets/icons/today.png" >
                        </template>
                        </v-text-field>
                    </template>
                    <v-date-picker
                        v-model="selectDateStatus"
                        no-title
                        @input="menuDate = false"
                    ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row class="d-flex">
                  <v-spacer/>
                  <v-btn
                    class="head-search-button mr-2"
                    outlined
                    color="primary"
                    style="width: 60px;"
                    elevation="0"
                    @click="resetFilterData()"
                  >ล้าง</v-btn>
                  <v-btn
                    class="btn-search-dep ml-2 mr-3"
                    color="primary"
                    style="width: 94px;"
                    dark
                    @click="searchFilterData()"
                  >ค้นหา</v-btn>
                </v-row>
              </v-card>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pt-0 d-flex align-end pl-12" style="padding-bottom: 0px;">
            <!-- <v-row class="px-4">
              <span>รายการสิทธิ์ย่อยทั้งหมด {{total.all}} รายการ</span>
            </v-row> -->
            <v-row class="px-0">
              <v-col cols="3" class="t">
                <span>รายการสิทธิ์ย่อยทั้งหมด {{total.all}} รายการ</span>
              </v-col>
              <v-col cols="4" class="align-start" style="margin-left: -6%;">
                <v-chip
                  :color="['approve','acknowledge'].includes('cancel')? '#ECF8EA': ['reject'].includes('cancel')? '#FBE5E4': ['pending'].includes('cancel')? '#FEF5E9': ['cancel'].includes('cancel')? '#F5F5F5':'#ECF9FF'"
                  :text-color="statusList.filter(e => e.status === 'cancel')[0].color"
                >
                  <span>{{ statusList.filter(e => e.status === 'cancel')[0].statusTH || '-' }}</span>
                </v-chip>
                <span class="mt-1 ml-1 mr-4">({{total.cancel}})</span>
                <v-chip
                :color="['approve','acknowledge'].includes('expire')? '#ECF8EA': ['reject'].includes('expire')? '#FBE5E4': ['pending'].includes('expire')? '#FEF5E9': ['cancel'].includes('expire')? '#F5F5F5':'#ECF9FF'"
                :text-color="statusList.filter(e => e.status === 'expire')[0].color"
              >
                <span>{{ statusList.filter(e => e.status === 'expire')[0].statusTH || '-' }}</span>
              </v-chip>
                <span class="mt-1 ml-1 mr-4">({{total.expire}})</span>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="px-12">
            <v-data-table
              :headers="headersPrimaryRole"
              :items="historyData"
              :items-per-page="5"
              class="border-table-employee text-no-wrap mt-1 elevation-0"
              item-key="no"
              :expanded.sync="expanded"
              hide-default-footer
              disable-sort
            >
            <template v-slot:item="{ item, index }">
              <tr style="cursor: pointer;">
                <td>{{ index + 1 }}</td>
                <td>{{ item.name }}</td>
                <td>{{ initDate(item.createAt)}}</td>
                <td>{{ initDateNoTime(item.startDate)}} - {{ initDateNoTime(item.endDate)}}</td>
                <!-- <td>{{ this.initDate(item.createAt)}}</td> -->
                <!-- <td>{{ item.company }}</td> -->
                <!-- <td>{{ item.transferDate }}</td> -->
                <td>
                  <v-chip
                    :color="['approve','acknowledge', 'active'].includes(item.status)? '#ECF8EA': ['reject', 'expire'].includes(item.status)? '#FBE5E4': ['pending'].includes(item.status)? '#FEF5E9': ['cancel', 'inActive'].includes(item.status)? '#F5F5F5':'#ECF9FF'"
                    :text-color="statusList.filter(e => e.status === item.status)[0].color"
                  >
                    <span>{{ statusList.filter(e => e.status === item.status)[0].statusTH || '-' }}</span>
                  </v-chip>
                </td>
                <td>
                  <v-chip
                  v-for="(item, i) in item.tag" :key="i"
                    :color="['approve','acknowledge'].includes('cancel')? '#ECF8EA': ['reject'].includes('cancel')? '#FBE5E4': ['pending'].includes('cancel')? '#FEF5E9': ['cancel'].includes('cancel')? '#F5F5F5':'#ECF9FF'"
                    :text-color="statusList.filter(e => e.status === 'cancel')[0].color"
                  >
                    <span>{{ item.name }}</span>
                  </v-chip>
                </td>
                <!-- <td>{{ item.expireRole }}</td> -->
              </tr>
            </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card>
    </div>
    <v-dialog v-model="dialogConfirmDel" max-width="500px">
      <v-card height="180px">
        <v-card-title class="ra-head-text-bold justify-center pa-5">ต้องการลบข้อมูลนี้ใช่ไหม</v-card-title>
        <v-card-text class="justify-center text-center">
        <span class="ra-head-text justify-center">คุณแน่ใจหรือไม่ว่าต้องการลบข้อมูล</span>
        <!-- <span v-else-if="titleDialog === 'temporaryer'" class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลผู้รักษาการคนนี้</span> -->
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn class="ra-button1" color="#1654C6" outlined @click="dialogConfirmDel = false">ยกเลิก</v-btn>
          <v-btn class="ra-button1" color="#1654C6" dark @click="deleteBusiness()">ยืนยัน</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirmCancel" max-width="500px">
      <v-card height="180px">
        <v-card-title class="ra-head-text-bold justify-center pa-5">ต้องการยกเลิกสิทธิ์นี้ใช่ไหม</v-card-title>
        <v-card-text class="justify-center text-center">
        <span class="ra-head-text justify-center">คุณแน่ใจหรือไม่ว่าต้องการยกเลิกสิทธิ์</span>
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn class="ra-button1" color="#1654C6" outlined @click="dialogConfirmCancel = false">ยกเลิก</v-btn>
          <v-btn class="ra-button1" color="#1654C6" dark @click="cancelRole()">ยืนยัน</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        :color="snackbarColor"
        absolute
        text
        top
      >
      <v-icon left dark small :color="snackbarColor">fa-check-circle</v-icon>
      <span :style="{ 'color': `${snackbarColor}` }">{{ text }}</span>
      </v-snackbar>
    </div>
    <dialogRoleRenewal/>
  </div>
</template>

<script>
// import swal from 'sweetalert'
import moment from 'moment'
import { EventBus } from '@/EventBus'
import dialogRoleRenewal from '../../_managetransferrole/_dialog/dialogRoleRenewal'
import OverlayLoading from '../../_template/OverlayLoading.vue'
// import DialogAddAprover from '../../manageCompany/_dialog/dialogAddApprover'
import {
} from '@/API/API'
// const axios = require('axios')

export default {
  components: {
    dialogRoleRenewal,
    OverlayLoading
  },
  name: 'overview',
  data () {
    return {
      loading: false,
      expanded: [],
      snackbar: false,
      menu: false,
      menuDate: false,
      timeout: 2000,
      snackbarColor: '',
      text: '',
      dialogDeleteApprover: false,
      dialogApproverCompany: false,
      dialogConfirmCancel: false,
      dialogConfirmDel: false,
      comment: '',
      titleDialog: '',
      itemConfirmDelete: [],
      panel: [0, 1],
      chkDataEmp: 0,
      userDataStore: '',
      tokenUser: '',
      userIdList: [],
      userIdListTemporary: [],
      statusApproveRole: 'approve',
      historyData: [],
      authenList: [],
      statusAuthenList: [],
      selectAuthenList: '',
      selectStatusAuthenList: '',
      selectDateStatus: '',
      total: '',
      orgChartDetail: '',
      company: '',
      secRoleData: [
        {
          no: '1',
          primaryRole: 'test',
          transferDate: 'Date',
          expireRole: 'Expire',
          comExpireRole: 'testExpire',
          status: 'pending'

        }
      ],
      isSelecting: false,
      valid: true,
      inputRules: [
        v => !!v || 'กรุณากรอกข้อมูล'
      ],
      headersPrimaryRole: [
        {
          text: 'ลำดับ',
          align: 'start',
          sortable: false,
          value: 'no'
        },
        { text: 'สิทธิ์ย่อย', value: 'name' },
        { text: 'วันที่โอนสิทธิ์', value: 'createAt' },
        { text: 'ระยะเวลาที่มีสิทธิ์', value: 'transferDate' },
        // { text: 'ใกล้หมดอายุ', value: 'transferDate' },
        { text: 'สถานะ', value: 'endDate' },
        { text: 'Tag', value: 'tag' }
        // { text: 'จัดการ', value: 'actions', sortable: false }
      ],
      statusList: [
        // { status: 'pending', statusTH: 'กำลังดำเนินการ', color: '#00B0FF' },
        { status: 'pending', statusTH: 'รออนุมัติ', color: '#E9A016' },
        { status: 'approve', statusTH: 'อนุมัติแล้ว', color: '#58A144' },
        { status: 'reject', statusTH: 'ไม่อนุมัติ', color: '#D1392B' },
        { status: 'cancel', statusTH: 'ยกเลิก', color: '#757575' },
        { status: 'acknowledge', statusTH: 'รับทราบแล้ว', color: '#58A144' },
        { status: 'active', statusTH: 'โอนสิทธิ์แล้ว', color: '#58A144' },
        { status: 'expire', statusTH: 'หมดอายุ', color: '#D1392B' },
        { status: 'inActive', statusTH: 'ยกเลิก', color: '#757575' }
      ]
    }
  },
  mounted () {
    EventBus.$on('addAprover', this.add)
  },
  beforeDestroy () {
    EventBus.$off('addAprover')
  },
  async created () {
    this.loading = true
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    this.propsitems = this.$route.params.id
    this.propsitemsOrgchart = this.$route.params.orgchartId
    if (!this.$store.state.token) {
      this.goBack()
    } else {
      await this.getSelectHistory(this.propsitems, this.propsitemsOrgchart)
      await this.getHistoryDetail(this.propsitems, this.propsitemsOrgchart)
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
    goBack () {
      // this.$router.push('/managetransferrole')
      this.$router.go(-1)
    },
    cancel () {
      this.$router.go(-1)
    },
    openDialogRoleExpire () {
      EventBus.$emit('dialogRoleRenewal')
    },
    onImgError (i) {
      this.approver[i].failed_image = true
    },
    checkCancel () {
      this.dialogConfirmCancel = true
    },
    async searchFilterData () {
      await this.getHistoryDetail(this.propsitems, this.propsitemsOrgchart)
    },
    async resetFilterData () {
      this.selectAuthenList = ''
      this.selectStatusAuthenList = ''
      this.selectDateStatus = ''
      await this.getHistoryDetail(this.propsitems, this.propsitemsOrgchart)
    },
    async getSelectHistory (id, orgchartId) {
      await this.axios({
        method: 'post',
        url: `${this.api}/api/vMonk/authenTransfer/historyAuthenSelect`,
        headers: {
          authorization: this.tokenUser
        },
        data: {
          // orgchartId: '6188ca4583cee44edcc26412'
          orgchartId: orgchartId
        }
      }).then((response) => {
        this.authenList = response.data.result[0].authenName
        this.statusAuthenList = response.data.result[0].status
        // console.log('revers/e', this.itemCompany)
      }).catch(e => {
        console.log(e)
      })
    },
    async getHistoryDetail (id, orgchartId) {
      this.loading = true
      await this.axios({
        method: 'post',
        url: `${this.api}/api/vMonk/authenTransfer/historyAuthen`,
        headers: {
          authorization: this.tokenUser
        },
        data: {
          orgchartId: orgchartId,
          authenId: [this.selectAuthenList],
          status: [this.selectStatusAuthenList],
          date: this.selectDateStatus
        }
      }).then((response) => {
        this.historyData = response.data.result
        this.orgChartDetail = response.data.orgchart.orgChartName
        this.company = response.data.company.companyName
        this.total = response.data.count
        this.loading = false
      }).catch(e => {
        console.log(e)
        this.loading = false
      })
    },
    initDate (date) {
      return moment(date).format('DD/MM/YYYY HH:mm น.')
    },
    initDateNoTime (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    goCreateTransfer () {
      this.$router.push({
        name: 'manageTransferrolecreateTransferrole',
        params: {
          type: 'new',
          id: this.propsitems,
          orgchartId: this.propsitemsOrgchart
        }
      })
    }
  }
}
</script>
<style scoped>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0 !important;
}
.v-input {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}
.txt-font {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 5px;
  color: #757575;
}
.txt-font-value {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  color: #333333;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
/* src\assets\logo.png */
/* '@/assets/icons/no_user.png' */
/* src\assets\icons\no_user.png */
.file-input {
  display: none;
}
.button {
  border: none;
  color: white;
  /* padding: 15px 32px; */
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
}
label {
  background-color: indigo;
  color: white;
  /* padding: 0.5rem; */
  padding: 0.7rem;
  font-family: sans-serif;
  border-radius: 0.3rem;
  cursor: pointer;
  margin-top: 1rem;
}
/* upfile pdf */
div.file-listing{
  width: 800px;
}
input[type="file"]{
  position: absolute;
  top: -500px;
  display:none;
}

  /* อัปโหลดไฟล์ */
  .upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.btn_click {
  border: 2px solid gray;
  /* color: gray; */
  background-color: white;
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: bold;
}

.upload-btn-wrapper input[type=file] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}

.ra-head-text-bold {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* Color / Primary / Hover */

  color: #1654C6;
}
.ra-head-text {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
}
.ra-span-text {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #757575;
}
.radio-border {
  height: 45px;
  border: 2px solid #ddd;
  border-radius: 5px;
  padding: 15px;
}
tr.v-data-table__selected {
    background: #7d92f5 !important;
  }
</style>
